import PropTypes from 'prop-types';
import { useContext } from 'react';
import {
  NO_SUBSCRIPTION_PURCHASE_FOUND,
  RESTORE_PURCHASE_FAILED,
  RESTORE_PURCHASE_SUCCESS,
} from 'src/common/constants/localizations/settings';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import OkDialog from '../../shared/dialog/OkDialog';
import css from '../devices/add-device-success-dialog.module.scss';

export const dialogs = {
  success: 'success',
  failure: 'failure',
  noPurchase: 'noPurchase',
};

const dialogHeadingMap = {
  [dialogs.success]: RESTORE_PURCHASE_SUCCESS,
  [dialogs.failure]: RESTORE_PURCHASE_FAILED,
  [dialogs.noPurchase]: NO_SUBSCRIPTION_PURCHASE_FOUND,
};

const dialogIdMap = {
  [dialogs.success]: 'restorePurchaseSuccessDialog',
  [dialogs.failure]: 'cannotRestorePurchaseDialog',
  [dialogs.noPurchase]: 'noSubscriptionPurchaseDialog',
};

const RestoreResultDialog = ({ shouldShow, handleClose, dialog }) => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);

  return (
    <OkDialog
      shouldShow={shouldShow}
      handleClose={handleClose}
      heading={<div className={css.heading}>{getLocalizedText(dialogHeadingMap[dialog])}</div>}
      dataTestId={dialogIdMap[dialog]}
    />
  );
};

RestoreResultDialog.propTypes = {
  shouldShow: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  dialog: PropTypes.string.isRequired,
};

export default RestoreResultDialog;
